module.exports = __webpack_public_path__ + "img/mexicoCity.423ccac3.jpg";